import { render, staticRenderFns } from "./TableHorarios.vue?vue&type=template&id=6722c986&scoped=true&"
import script from "./TableHorarios.vue?vue&type=script&lang=js&"
export * from "./TableHorarios.vue?vue&type=script&lang=js&"
import style0 from "./TableHorarios.vue?vue&type=style&index=0&id=6722c986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722c986",
  null
  
)

export default component.exports